import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Component } from '@angular/core';

@Component({
    selector: 'app-change',
    templateUrl: './change.html'
})
export class ChangeComponent {

    categorie = [
        'informatore',
        'collega',
        'collaboratore',
        'tecnico',
        'privato',
        'amico',
        'altro'
    ];
    categoria: string;

    constructor(public activeModal: NgbActiveModal) { }

    setCategory(cat: string) {
        this.categoria = cat;
    }
}



// WEBPACK FOOTER //
// ./src/app/rubrica/changeCategory/change.ts